<script>
    import { required, minLength, numeric } from "vuelidate/lib/validators";
    import validationMessages from '@/components/validations'
    import vue2Dropzone from "vue2-dropzone";
    import "vue2-dropzone/dist/vue2Dropzone.min.css";
    import Games from "@/services/Games";
    import flatPickr from "vue-flatpickr-component";
    import "flatpickr/dist/flatpickr.css";
    export default {
        props:['groupOptions'],
        components:{
            validationMessages, vueDropzone: vue2Dropzone, flatPickr
        },
        data() {
            return {
                csrf_token: localStorage.getItem('csrf_token'),
                question:'',
                active_from:'',
                active_from_time:'',
                active_to:'',
                active_to_time:'',
                answers: [{ answer: "" }],
                min_answers: 0,
                image_url: null,
                recipient:'',
                selected_group_id:'',
                audienceOptions: [
                { value: 'ALL', text: 'All users' },
                { value: 'GROUP', text: 'User segment(group)' },
              ],
                photoDeletedCompanyImage : false ,
                photoDeletedLogoUrl : false ,
                submitted: false,
                showModal: false,
                tryingToEdit: false,
                verified_checked: true,
                datetimeconfig: {
                  enableTime: true,
                  time_24hr: true,
                  minuteIncrement: 1,
                  dateFormat: "Y-m-d H:i:S",
                },
                dropzoneOptions_primary: {
                    url: '/',
                    autoProcessQueue: false,
                    addRemoveLinks: true,
                    thumbnailWidth: 200,
                    thumbnailMethod: 'contain',
                    maxFilesize: 4,
                    acceptedFiles: 'image/jpeg,image/png,image/bmp,image/webp',
                    maxFiles: 3,
                },
                dateconfig: {
                  enableTime: false,
                  dateFormat: "Y-m-d",
                  minDate: new Date(),
                },
                timeconfig: {
                  enableTime: true,
                  noCalendar: true,
                  time_24hr: true,
                  minuteIncrement: 1,
                  dateFormat: "H:i",
                  allowInput:true
                },
            };
        },
        validations: {
           question:{
             required
           },
          active_from:{
             required
          },
          active_from_time:{
             required
          },
          active_to:{
             required
          },
          active_to_time:{
            required
          },
          recipient:{
            required
          },
         
        },
        computed:{
          hasGroupSelection() {
            return this.recipient === 'GROUP'
          },
        },

        methods: {
          openDatePickerFrom() {
            this.$refs.datePickerFrom.$el.click();
          },
          openDatePickerTo(){
            this.$refs.datePickerTo.$el.click();
          },
          openTimePicker() {
            this.$refs.timePicker.$el.click();
          },
          openTimePickerFrom(){
               this.$refs.timePickerFrom.$el.click();
          },
          openTimePickerTo(){
            this.$refs.timePickerTo.$el.click();
          },
          addAnswerField(){
              this.answers.push({ answer: "" });
          },
          removeAnswerField(index){
            if(this.answers.length === 1) return;
            this.answers.splice(index, 1);
          },

            async addPoll(){
                this.tryingToEdit = true;
                this.submitted = true;
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.tryingToEdit = false;
                    return;
                } else {
                    try {
                      if (this.answers[0].answer === ''){
                        this.answers = {}
                      }
                      let selecteGroup = '';

                      if(this.hasGroupSelection){
                        selecteGroup = this.selected_group_id
                      }else{
                        selecteGroup = ''
                      }

                        await Games.addPoll({
                            question: this.question,
                            active_from: `${this.active_from} ${this.active_from_time}:00`,
                            active_to: `${this.active_to} ${this.active_to_time}:00`,
                            answers: this.answers,
                            min_answers: this.min_answers,
                            image: this.image_url,
                            recipient: this.recipient,
                            group_id:selecteGroup,
                            csrf_token: this.csrf_token
                        }).then((response) => {
                            this.successmsg("Changes has been saved");
                            this.closeModal();
                        }).catch(error => {
                            this.error = error.response.data.error ? error.response.data.error : "";
                            this.failedmsg(this.error)
                        }).finally(() => {
                            this.refreshData()
                            this.tryingToEdit = false
                        })
                    } catch (error) {
                        this.error = error.response.data.error ? error.response.data.error : "";
                        this.failedmsg(this.error)
                    }
                }
                this.tryingToEdit = false;
            },

            selectFileImageUrl(files) {
                setTimeout(() => {
                    let queuedFiles = this.$refs.myVueDropzone_image_url.getQueuedFiles();
                    if (queuedFiles.length > 1) {
                        this.failedmsg('You can only have one logo url');

                        files.forEach((value) => {
                            this.$refs.myVueDropzone_image_url.removeFile(value);
                        });

                    }
                    this.image_url = queuedFiles[0] || null;
                    this.photoDeletedLogoUrl = false;
                }, 250);
            },

            refreshData() {
                this.$emit('onRefresh')
            },
            closeModal() {
                this.showModal = false
                this.resetProps()
            },
            resetProps(){
                this.question = ''
                this.active_from = ''
                this.active_from_time = ''
                this.active_to = ''
                this.active_to_time = ''
                this.answers = [{ answer: "" }]
                this.min_answers = 0
                this.image_url = null
                this.submitted = false
                this.recipient = '';
                this.selected_group_id = '';
            }
        },
    };
</script>

<template>
  <b-modal
    v-model="showModal"
    size="xl"
    @hidden="resetProps"
    id="add_new_poll"
    hide-header
    hide-footer
    body-class="p-0"
    centered
  >
    <div class="poll-modal">

      <!-- HERO -->
      <header class="poll-modal__hero">
        <h2>Add New Poll</h2>
        <p>Create a new poll question and answers</p>
      </header>

      <b-form @submit.prevent="addPoll">

        <!-- RECIPIENTS -->
        <section class="poll-card">
          <header class="poll-card__header">
            <h3>Recipients</h3>
            <p>Choose who can see this poll</p>
          </header>

          <b-form-group label="Target audience *" class="mb-0">
            <b-form-select
              v-model="recipient"
              :options="audienceOptions"
              :class="{ 'is-invalid': submitted && $v.recipient.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Target audience'"
              :validationName="$v.recipient"
            />
          </b-form-group>

          <b-form-group
            v-if="hasGroupSelection"
            label="User segment *"
            class="mt-4 mb-0"
          >
            <b-form-select
              v-model="selected_group_id"
              :options="groupOptions"
              :class="{ 'is-invalid': submitted && $v.selected_group_id && $v.selected_group_id.$error }"
            />
          </b-form-group>
        </section>

        <!-- POLL QUESTION + DATES -->
        <section class="poll-card">
          <header class="poll-card__header">
            <h3>Poll Question</h3>
            <p>Enter your poll question and select the active period</p>
          </header>

          <b-form-group label="Poll Question *" class="mb-4">
            <b-form-input
              v-model.trim="question"
              :class="{ 'is-invalid': submitted && $v.question.$error }"
            />
            <validationMessages
              v-if="submitted"
              :fieldName="'Poll Question'"
              :validationName="$v.question"
            />
          </b-form-group>

          <div class="row g-3 flex-wrap">
            <!-- FROM -->
            <div class="col-12 col-lg-6">
              <div class="poll-datetime">
                <span class="poll-datetime__label">From</span>

                <div class="poll-datetime__inputs">
                  <div class="poll-input-icon">
                    <flat-pickr
                      v-model="active_from"
                      :config="dateconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_from.$error }"
                    />
                    <i class="uil uil-calendar-alt poll-input-icon__icon"
                       @click="openDatePickerFrom"></i>
                  </div>

                  <div class="poll-input-icon">
                    <flat-pickr
                      v-model="active_from_time"
                      :config="timeconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_from_time.$error }"
                    />
                    <i class="uil uil-clock poll-input-icon__icon"
                       @click="openTimePickerFrom"></i>
                  </div>
                </div>
              </div>
            </div>

            <!-- TO -->
            <div class="col-12 col-lg-6">
              <div class="poll-datetime">
                <span class="poll-datetime__label">To</span>

                <div class="poll-datetime__inputs">
                  <div class="poll-input-icon">
                    <flat-pickr
                      v-model="active_to"
                      :config="dateconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_to.$error }"
                    />
                    <i class="uil uil-calendar-alt poll-input-icon__icon"
                       @click="openDatePickerTo"></i>
                  </div>

                  <div class="poll-input-icon">
                    <flat-pickr
                      v-model="active_to_time"
                      :config="timeconfig"
                      class="form-control pe-4"
                      :class="{ 'is-invalid': submitted && $v.active_to_time.$error }"
                    />
                    <i class="uil uil-clock poll-input-icon__icon"
                       @click="openTimePickerTo"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <!-- POLL ANSWERS -->
        <section class="poll-card">
          <header class="poll-card__header">
            <h3>Poll Answers</h3>
            <p>Add answers to the poll</p>
          </header>

          <div
            v-for="(answer, index) in answers"
            :key="index"
            class="mb-3 border rounded-3 p-3"
          >
            <div class="d-flex align-items-start gap-2">
              <b-form-input
                v-model.trim="answer.answer"
                :class="{ 'is-invalid': submitted && !answer.answer }"
              />

              <b-button
                v-if="answers.length > 1"
                variant="outline-danger"
                @click.prevent="removeAnswerField(index)"
              >
                <i class="uil uil-trash-alt"></i>
              </b-button>
            </div>
          </div>

          <b-button
            size="sm"
            variant="outline-primary"
            @click.prevent="addAnswerField"
          >
            + Add Poll Answer
          </b-button>
        </section>

        <!-- IMAGE -->
        <section class="poll-card">
          <header class="poll-card__header">
            <h3>Poll Image</h3>

            <p>Upload an image for the poll (optional). Recommended: 910x350 pixels.</p>
          </header>

          <div class="poll-upload">
            <vue-dropzone
              ref="myVueDropzone_image_url"
              :use-custom-slot="true"
              :options="dropzoneOptions_primary"
              @vdropzone-files-added="selectFileImageUrl"
              no-progress-bar
            >
              <div class="poll-upload__placeholder">
                <i class="uil uil-import"></i>
                <span>Drag and drop an image, or click to browse</span>
                <small>PNG, JPG up to 4MB</small>
              </div>
            </vue-dropzone>
          </div>
        </section>

        <!-- FOOTER -->
        <footer class="poll-modal__footer">
          <b-button variant="outline-secondary" @click="closeModal">
            Cancel
          </b-button>

          <b-button variant="dark" type="submit" :disabled="tryingToEdit">
            <b-spinner v-if="tryingToEdit" small class="me-2" />
            Submit Poll
          </b-button>
        </footer>

      </b-form>
    </div>
  </b-modal>
</template>

<style scoped>
.poll-modal {
  padding: 32px;
  background: #f7f8fb;
}

.poll-modal__hero {
  margin-bottom: 24px;
}

.poll-modal__hero h2 {
  font-weight: 600;
  font-size: 28px;
  margin-bottom: 8px;
  color: #151a2d;
}

.poll-modal__hero p {
  margin: 0;
  color: #5f6b7d;
  font-size: 16px;
}

.poll-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 28px;
  margin-bottom: 24px;
  box-shadow: 0 12px 32px rgb(15 23 42 / 6%);
}

.poll-card__header h3 {
  margin-bottom: 4px;
  font-size: 20px;
  font-weight: 600;
  color: #151a2d;
}

.poll-card__header p {
  margin-bottom: 24px;
  color: #5f6b7d;
}

.poll-datetime {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.poll-datetime__label {
  font-weight: 600;
  color: #151a2d;
}

.poll-datetime__inputs {
  display: flex;
  gap: 12px;
  align-items: center;
}

.poll-input-icon {
  position: relative;
  flex: 1;
}

.poll-input-icon__icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #5f6b7d;
  font-size: 18px;
  cursor: pointer;
  pointer-events: auto;
}

.poll-input-icon .form-control {
  width: 100%;
}

.poll-datetime__inputs .form-control {
  padding: 12px 16px;
  border-radius: 12px;
  background: #f1f3f7;
  border: 1px solid transparent;
}

.poll-datetime__inputs .form-control:focus {
  border-color: #6366f1;
  background: #ffffff;
  box-shadow: none;
}

.poll-upload {
  border: 2px dashed #d3d8e6;
  border-radius: 16px;
  background: #f7f8fb;
  padding: 32px;
  transition: border-color 0.2s ease, background 0.2s ease;
}

.poll-upload.is-invalid {
  border-color: #f97373;
}

.poll-upload.has-error {
  border-color: #f97373;
  background: #fff5f5;
}

.poll-upload__placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  color: #5f6b7d;
  font-size: 14px;
}

.poll-upload__placeholder i {
  font-size: 32px;
  color: #151a2d;
}

.poll-upload__placeholder small {
  color: #a0aec0;
}

.poll-modal__footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 12px;
}

@media (max-width: 767.98px) {
  .poll-modal {
    padding: 20px;
  }

  .poll-card {
    padding: 20px;
  }

  .poll-datetime__inputs {
    flex-direction: column;
    align-items: stretch;
  }
}
</style>